<template>
  <div class="c-card card">
    <router-link
      :to="actionUrl"
      @mouseenter.native="$eventHub.$emit('morphCursor', 'circle')"
      @mouseleave.native="$eventHub.$emit('morphCursor', 'rect')"
    >
      <AppPicture
        :data="{ src: image, alt: alt }"
        :lazy="true"
        :isImg="false"
      />

      <div class="card__content">
        <div class="card__title" v-html="title"></div>
        <div class="card__description" v-html="description"></div>
        <AppButton
          class="card__button"
          :data="{ content: actionLabel, url: actionUrl }"
          theme="dark"
          :isAnimated="false"
          :isHoverable="false"
        />
      </div>
    </router-link>
  </div>
</template>

<script>
import AppPicture from '@/components/AppPicture.vue';
import AppButton from '@/components/AppButton.vue';

export default {
  name: 'AppCard',

  components: {
    AppPicture,
    AppButton,
  },

  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    image: {
      type: String,
    },
    alt: {
      type: String,
    },
    actionLabel: {
      type: String,
    },
    actionUrl: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  a {
    display: block;
  }

  @include mq($and: $is-not-touch-device) {
    &:hover {
      .button {
        transform: translateY(0px);
        opacity: 1;
      }
    }
  }

  &__content {
    position: relative;
    width: 120%;
    margin-left: -10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @include mq($until: ipadP) {
      margin-left: 0;
      width: 100%;
    }

    .button {
      transform: translateY(10px);
      opacity: 0;
      transition: transform .3s $outBack,
        opacity .3s $outBack;

      @include mq($and: $is-touch-device) {
        opacity: 1;
        transform: none;
        transition: none;
      }
    }
  }

  &__title {
    font-size: 3em;
    color: var(--color-headline-light);
    text-align: center;
    margin-top: -30px;

    @include mq($until: ipadP) {
      font-size: 2.5em;
    }
  }

  &__description {
    margin: 30px auto;
    text-align: center;

    font-size: 16px;

    @include mq($from: dm) {
      font-size: 20px;
    }

    @include mq($from: dxl) {
      font-size: 24px;
    }

    @include mq($until: ds) {
      width: 90%;
    }
  }

  &__description ::v-deep p {
    max-width: 100%;
    color: $color-white;
  }
}
</style>
<style lang="scss">
.c-card {
  @include mq($and: $is-not-touch-device) {
    & .picture__img {
      opacity: 0.7;
      transition: transform .4s $outCirc,
        opacity .4s $outBack;
    }
    &:hover .picture__img {
      opacity: 1;
      transform: scale(1.1);
      transition: transform .4s $outBack,
        opacity .4s $outBack
    }
  }
}
</style>
